module.exports = __webpack_public_path__ + "img/health14_7-9-2021.e251f2bd.jpg";